import JobUpdateForm from "./job-update-form";

export default JobUpdateForm;